/* eslint-disable max-len */
import { createSvgIcon } from "../../utils";

// SVG - 32 width, 32 height

const ShareFacebook = createSvgIcon(
    <path
        d="M32 16.098C32 7.208 24.837 0 16 0S0 7.207 0 16.098C0 24.133 5.85 30.792 13.5 32V20.751H9.437v-4.653H13.5V12.55c0-4.034 2.389-6.263 6.043-6.263 1.75 0 3.582.315 3.582.315v3.961h-2.017c-1.988 0-2.608 1.241-2.608 2.515v3.019h4.438l-.71 4.653H18.5V32C26.15 30.792 32 24.133 32 16.098z"
        fill="#1877F2"
    />,
    "ShareFacebook",
);

export default ShareFacebook;
